module.exports = __webpack_public_path__ + "img/di-3-fang_02.c9895344.jpg";